const SUCCESS_CODE = /^2\d{2}$/

class Response {
  constructor(rawResponse) {
    this.response = rawResponse
    this.status = rawResponse.status
    this.data = rawResponse.data

    if (!this.success()) {
      this.data = {
        ...this.data,
        errorResponseStatus: this.status,
      }
    }
  }

  success() {
    return SUCCESS_CODE.test(this.status)
  }
}

export default Response
